// Maps each notification Module straight to its real in-app route (see
// guide/route.md in the mobile app repo, and Routes.deepLink()'s
// registry.ts) - the deep link is derived automatically from the selected
// Module + its id, not picked separately. "{id}" is replaced with the
// module's id value (module_id, or category_id for the two SERVICE_*
// modules - see computeDeepLink below); a template with no "{id}" is a
// fixed path that needs no id at all. null means no mobile route exists for
// that module yet (REFERRAL) - falls back to the server's default link.
// EXTERNAL and OTHERS both just forward whatever the admin typed into the
// id field: EXTERNAL wraps it as "<External>..." (opens outside the app,
// the format Routes.deepLink() requires for that); OTHERS sends it as-is,
// for a bare in-app path or an "<External>"/"<Internal>" tagged URL the
// admin provides directly.
export const MODULE_DEEP_LINK_MAP: Record<string, string | null> = {
  SCHEME: "/user/schemes/details?id={id}",
  JOB: "/user/jobs/details?id={id}",
  SURVEY: "/user/conduct-survey?id={id}",
  HOSPITAL: "/user/hospital",
  SERVICES: "/user/services/details?id={id}",
  NEEDS: "/user/needs",
  EXTERNAL: "<External>{id}",
  // CMS today only has a user-facing details screen for News - Banners/AMI
  // For You/App Polling have no dedicated route yet.
  CMS: "/user/news/details?id={id}",
  PROFILE: "/user/profile",
  HOMEPAGE: "/user/home",
  REFERRAL: null,
  SERVICE_CATEGORY: "/user/services/search?category={id}",
  // route.md's services search has no subCategory param yet - links to the
  // category-filtered list (the closest valid destination) until it does.
  SERVICE_SUBCATEGORY: "/user/services/search?category={id}",
  OTHERS: "{id}",
};

/** The deep link for a given module + id value, or "" when it can't be
 * resolved yet (no route for this module, or it needs an id that hasn't
 * been entered). Empty means the server falls back to its default link. */
export function computeDeepLink(module: string | undefined | null, idValue: string | number | null | undefined): string {
  if (!module) return "";
  const template = MODULE_DEEP_LINK_MAP[module];
  if (!template) return "";
  if (!template.includes("{id}")) return template;
  if (idValue === null || idValue === undefined || idValue === "") return "";
  return template.replace("{id}", String(idValue));
}

export const moduleTypes = [
  { key: "SCHEME", value: "SCHEME" },
  { key: "JOB", value: "JOB" },
  { key: "SURVEY", value: "SURVEY" },
  { key: "HOSPITAL", value: "HOSPITAL" },
  { key: "SERVICES", value: "SERVICES" },
  { key: "NEEDS", value: "NEEDS" },
  { key: "EXTERNAL", value: "EXTERNAL" },
  { key: "CMS", value: "CMS" },
  { key: "PROFILE", value: "PROFILE" },
  { key: "HOMEPAGE", value: "HOMEPAGE" },
  { key: "REFERRAL", value: "REFERRAL" },
  { key: "SERVICE CATEGORY", value: "SERVICE_CATEGORY" },
  { key: "SERVICE SUBCATEGORY", value: "SERVICE_SUBCATEGORY" },
  { key: "OTHERS", value: "OTHERS" },
] as const;


export const labels = [
    { label: "Title" },
    { label: "Module" },
    { label: "Campaign ID" },
    { label: "Created At" },
    { label: "Total Uploaded" },
    { label: "Total Sent" },
    { label: "Status" },
    { label: "Success" },
    { label: "Failed" },
    { label: "Actions" },

];

export const scheduledLabels = [
    { label: "Title" },
    { label: "Module" },
    { label: "Campaign ID" },
    { label: "Created Date" },
    { label: "Scheduled At" },
    { label: "Total Uploaded" },
    { label: "Status" },
    { label: "Success" },
    { label: "Failed" },
    { label: "Actions" },
];

export function getNotificationStatusColor(status?: string) {
  switch (status) {
    case "completed":
      return "green";
    case "inprogress":
      return "orange";
    case "scheduled":
      return "#1976d2";
    case "cancelled":
      return "#7C797C";
    case "failed":
      return "red";
    default:
      return "black";
  }
}